import { useTranslation } from "react-i18next";

import { Window } from "components/window";
import { type BaseWindowProps } from "contexts/windows";

import { SettingsContent } from "./components";

/**
 * Settings Window Component
 *
 * Displays application settings.
 */
export function SettingsWindow({
    onClose,
    position = {
        elementId: "quick-access-camera",
        placement: "left",
        align: { vertical: "top" },
    } as const,
    ...props
}: BaseWindowProps) {
    const { t } = useTranslation();
    return (
        <Window
            position={position}
            size={{ width: 400, height: 400 }}
            autoHeight
            title={t("settings")}
            onClose={onClose}
            data-testid="settings-window"
            {...props}
        >
            <SettingsContent />
        </Window>
    );
}
